import { useAssessments } from './hooks';
import { IColumnDefinition, paths } from '@common/types';
import { AssessmentsTable } from './components';
import { EditAssessment } from '@views/pages/Patient/components/Assessments/components/EditAssessment';
import { LibraryAddCheck } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import { CreateAssessment } from '@views/pages/Patient/components/Assessments/components/CreateAssessment';

const columns: IColumnDefinition[] = [
  {
    id: 'type',
    label: 'Assessment',
    sortable: true,
  },
  {
    id: 'date',
    label: 'Assessment date',
    sortable: true,
  },
  {
    id: 'action',
    label: '',
    sortable: false,
  },
];

interface IAssessmentsProps {
  patient: paths[`/patient/{patient_id}`]['get']['responses']['200']['content']['application/json'];
  isEditDisabled: boolean;
  isReadOnly: boolean;
  tabPanelInstrumentHeight: number;
}

export const Assessments = ({
  patient,
  isEditDisabled,
  tabPanelInstrumentHeight,
  isReadOnly,
}: IAssessmentsProps) => {
  const {
    totalCount,
    filters,
    setFilters,
    entries = [],
    isLoading,
    itemEditId,
    setItemEditId,
    handleCloseEditModal,
    handleResetFilter,
    isFilterDisabled,
    isInitialFilters,
  } = useAssessments(patient.id);

  return (
    <>
      {isInitialFilters && entries.length === 0 && !isLoading ? (
        <Box
          sx={{
            height: 'calc(100vh - 310px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <LibraryAddCheck
            sx={{ width: 64, height: 64, mb: 2 }}
            color='primary'
          />
          <Typography variant='h6'>
            {t('patient.assessments.table.noResults.title')}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.secondary', mb: 2 }}>
            {t('patient.assessments.table.noResults.subTitle')}
          </Typography>
          <CreateAssessment
            patient_id={patient.id}
            disabled={
              isEditDisabled ||
              isReadOnly ||
              patient.account_status === 'Inactive'
            }
            setItemEditId={setItemEditId}
          />
        </Box>
      ) : (
        <AssessmentsTable
          tabPanelInstrumentHeight={tabPanelInstrumentHeight}
          rows={entries}
          columns={columns}
          filters={filters}
          setFilters={setFilters}
          handleResetFilter={handleResetFilter}
          totalCount={totalCount}
          loading={isLoading}
          patient_id={patient.id}
          setItemEditId={setItemEditId}
          disabled={isEditDisabled || patient.account_status === 'Inactive'}
          isFilterDisabled={isFilterDisabled}
          isReadOnly={isReadOnly}
        />
      )}

      {itemEditId && !isEditDisabled && (
        <EditAssessment
          assessment_id={itemEditId}
          patient_id={patient.id}
          handleClose={handleCloseEditModal}
        />
      )}
    </>
  );
};
